//存折线图数据数据
export const GET_RECORD_DATA = "get_record_data";
//请求折线图数据数据
export const REQ_RECORD_DATA = "req_record_data";
